import getLogger from '@zg-rentals/particles-js-browser-logger';

const requestIdMetaTag = document.querySelector('meta[name=request_id]');

let requestId = '';

if (requestIdMetaTag) {
    requestId = requestIdMetaTag.getAttribute('content');
}

const log = getLogger({
    type: 'pino',
    loggerArgs: {
        name: 'rental-manager-web',
        transmitLogPath: `/rental-manager/growth/log?requestId=${requestId}`
    }
});

global.log = log;

export default log;
